export const SITE_URL = "https://shop.myperfume.group";
export const SITE_NAME = "My Perfume";
export const DEFAULT_TITLE = "My Perfume — Luxury Perfumes & Fragrances";
export const DEFAULT_DESCRIPTION =
  "Shop luxury perfumes and fragrances at My Perfume. Discover signature scents, oud, and gift sets with worldwide shipping.";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/Images/logo/logo.webp`;
export const DEFAULT_LOCALE = "en_US";
export const DEFAULT_CURRENCY = "USD";

export const SOCIAL_LINKS = [
  "https://www.facebook.com/myperfume.group",
  "https://www.instagram.com/myperfume.group",
];

export const ORGANIZATION = {
  name: SITE_NAME,
  url: SITE_URL,
  logo: DEFAULT_OG_IMAGE,
  sameAs: SOCIAL_LINKS,
  contactPoint: [
    { telephone: "+961-81-441-597", contactType: "customer service", areaServed: "LB" },
    { telephone: "+961-81-33-22-67", contactType: "customer service", areaServed: "LB" },
  ],
  address: [
    {
      "@type": "PostalAddress",
      streetAddress: "El Maarad, Cheikh Nadim El Jisr Street",
      addressLocality: "Tripoli",
      addressCountry: "LB",
    },
    {
      "@type": "PostalAddress",
      streetAddress: "Riad Soloh Street",
      addressLocality: "Tripoli",
      addressCountry: "LB",
    },
  ],
};

export const buildCanonical = (path: string): string => {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${clean === "/" ? "" : clean}`;
};
